import { Content } from "@pathwright/ui/src/components/content/Content"
import FeedbackEditor from "../../block/BlockFeedback/edit"
import MatchingEditor from "./Matching/edit"
import MultipleChoiceEditor from "./MultipleChoice/edit"
import ParagraphEditor from "./Paragraph/edit"
import QuestionHeader from "./QuestionHeader"
import { QuestionContainer } from "./ui"

const QuestionEditor = (props) => {
  const { layout, blockStyles, data, onChange } = props

  const renderQuestion = () => {
    switch (layout) {
      case "multipleChoice":
        return <MultipleChoiceEditor {...props} />
      case "checkBoxes":
        return <MultipleChoiceEditor {...props} />
      case "matching":
        return <MatchingEditor {...props} />
      default:
        return <ParagraphEditor {...props} />
    }
  }

  return (
    <Content.Container>
      <QuestionContainer blockStyles={blockStyles}>
        <QuestionHeader {...props} />
        <div style={{ width: "100%" }}>{renderQuestion()}</div>
        <FeedbackEditor onChange={onChange} feedbackList={data.feedback} />
      </QuestionContainer>
    </Content.Container>
  )
}

export default QuestionEditor
